// Aktionsmodul: Wiedervorlage setzen. Kein Auto-Vorschlag (erzeugen() liefert immer
// null) — wird manuell im Aktions-Panel angelegt mit payload { wiedervorlage_am, notiz }.
import { supabase } from '../../supabase/client';
import type { AktionEntwurf, AktionKontext, AktionModul, TicketAktion } from '../types';

export function erzeugen(_ctx: AktionKontext): AktionEntwurf | null {
  return null;
}

export type WiedervorlagePayload = { wiedervorlage_am: string; notiz: string | null };

// Rein & testbar: validiert das payload einer Wiedervorlage-Aktion.
export function parseWiedervorlagePayload(
  payload: Record<string, unknown> | null | undefined,
): WiedervorlagePayload | null {
  if (!payload) return null;
  const wiedervorlageAm = payload.wiedervorlage_am;
  if (typeof wiedervorlageAm !== 'string' || wiedervorlageAm.length === 0) return null;
  const notiz = payload.notiz;
  return { wiedervorlage_am: wiedervorlageAm, notiz: typeof notiz === 'string' ? notiz : null };
}

// Dünner Supabase-Wrapper (Konvention: nicht unit-getestet). Bei ungültigem payload
// erfolgt bewusst KEIN DB-Write.
export async function ausfuehren(aktion: TicketAktion): Promise<{ ok: boolean; fehler?: string }> {
  const parsed = parseWiedervorlagePayload(aktion.payload);
  if (!parsed) return { ok: false, fehler: 'Ungültiges Wiedervorlage-Payload (wiedervorlage_am fehlt)' };

  const { error: updateError } = await supabase
    .from('tickets')
    .update({ wiedervorlage_am: parsed.wiedervorlage_am, wiedervorlage_notiz: parsed.notiz })
    .eq('id', aktion.ticket_id);
  if (updateError) return { ok: false, fehler: updateError.message };

  const { error: historieError } = await supabase.from('ticket_historie').insert({
    ticket_id: aktion.ticket_id,
    benutzer_id: null,
    aktion: 'wiedervorlage_gesetzt',
    neuer_wert: `Wiedervorlage: ${parsed.wiedervorlage_am}`,
  });
  if (historieError) return { ok: false, fehler: historieError.message };

  return { ok: true };
}

export const wiedervorlageModul: AktionModul = { typ: 'wiedervorlage', erzeugen, ausfuehren };
